<!-- Color Picker Input -->
@if (name) {
  <div class="w-full"
       [class.field]="formField">
    @if (label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1"
        [class.mb-2]="!formField"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
    <div class="flex flex-1 align-items-center w-full">
      <div medsurf-design-content-input-group class="relative">
        @if (supportsEyeDropper()) {
        <button medsurf-design-input-button
          [id]="'eye_dropper'"
          class="w-3rem"
          [title]="'global.eye_dropper' | translate"
          (click)="startEyeDropper()">
          <span 
            [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.EYE_DROPPER"
            [style.color]="control.value"
            [style.filter]="control.value ? 'invert(1) grayscale(1) contrast(255)' : undefined"
          ></span>
        </button>
      } @else {
        <button medsurf-design-input-button
          [id]="'eye_dropper'"
          class="w-3rem"
          [title]="'global.eye_dropper_reset' | translate"
          [style.background-color]="control.value || 'transparent'"
          (click)="resetColor()">
          <span 
            [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.TIMES"
            [style.color]="control.value"
            [style.filter]="control.value ? 'invert(1) grayscale(1) contrast(255)' : undefined"
          ></span>
        </button>
      }
        <p-dropdown inputId="{{ name }}"
          class="w-full medsurf-colorpicker"
          appendTo="body"
          ariaLabelledBy="{{ name }}_label"
          styleClass="{{ inputClass }}"
          panelStyleClass="{{ menuClass }}"
          formControlName="{{ name }}"
          [disableControl]="disabled"
          [options]="FlatModels.ColorConfigModels.colorPickerList"
          [placeholder]="'global.choose' | translate"
          optionLabel="name"
          optionValue="value"
          [colorPicker]="control.value"
          (colorPickerChange)="onColorChange($event)"
          cpPosition="bottom"
          [editable]="true"
          [ngClass]="{
            'ng-invalid': control.invalid && control.touched,
            'ng-dirty': control.invalid && control.touched
          }"
          (onChange)="valueChange.emit($event)">
          <ng-template pTemplate="selectedItem">
            <div class="flex align-items-center gap-2">
              <div>{{ control.value | translate }}</div>
            </div>
          </ng-template>
          <ng-template let-entry pTemplate="item">
            <div class="flex align-items-center gap-2">
              <div>{{ entry.name | translate }}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>
    @if (control.invalid && (control.dirty || control.touched)) {
      <br/>
      @for (err of control.errors | keyvalue; track err) {
        <small id="{{ name }}_help"
          class="p-error">
          {{ err.value | translate }}
        </small>
        <br/>
      }
    }
  </div>
}